
angular.module('bmsApp.training').factory('TrainingCourseSvc', function (CRUDSvc, TRAINING_COURSE_API) {

	return {
		create: function (trainingCourse) {
			return CRUDSvc.post(TRAINING_COURSE_API.CREATE, trainingCourse);
		},
		update: function (id, trainingCourse) {
			return CRUDSvc.post(TRAINING_COURSE_API.UPDATE + id, trainingCourse);
		},
		delete: function (id) {
			return CRUDSvc.get(TRAINING_COURSE_API.DELETE + id);
		},
		options: function () {
			return CRUDSvc.get(TRAINING_COURSE_API.OPTIONS);
		}
	};

}).constant('TRAINING_COURSE_API', {
	CREATE: 'api/trainingCourse/create',
	UPDATE: 'api/trainingCourse/update/',
	DELETE: 'api/trainingCourse/delete/',
	OPTIONS: 'api/trainingCourse/options'
});
